'use strict'
import Link from '@mui/material/Link'
import { Auth } from 'aws-amplify'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'

import {
  analysisMode,
  companySize as companySizeCode,
  listingClassification,
  orderBy,
  restApiKey,
  table,
  titleName
} from '../../_constants/Code'
import { mainPageInfoList, monitoringInfoList } from '../../_constants/PageInfoList'
import { PathInfoList } from '../../_constants/PathInfoList'
import { errorLog, warnLog } from '../../common/logger/Logger'
import { availabilityMiddleTitle, availabilitySmallTitle } from '../../common/utils/AnalysisModeUtil'
import { getDynamoDB } from '../../common/utils/DynamoDbUtils'
import {
  getBenchmarkCompany,
  getCsvByJson,
  getFileNameList,
  getIndustrySector,
  getObject,
  getPageText,
  readDashboardId
} from '../../common/utils/FileUtils'
import { httpGet } from '../../services/api/AmplifyApi'

import { debounce } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import FilterComponent from '../../_components/FilterComponent/FilterComponent'
import filterConfig from '../../_components/FilterComponent/FilterConfig'
import Forbidden from '../../_components/Forbidden'
import LoadingIcon from '../../assets/img/Loading/Loading.svg'
import { getLatestStdFmtData } from '../../common/utils/DataSetUtils'
import Bookmark, { BookmarkEmpty } from './control/Bookmark'
import CategoryTag, { CategoryTagEmpty } from './control/CategoryTag'
import _get from 'lodash/get'
import AggregateCondition from './QuickSight/AggregateCondition'
import { fetchLatestSecondmentType } from '../../_components/FilterComponent/filters/services'
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk'
import {
  getCustomDashboardComponent,
  isCustomDashboard
} from '../report/securitiesReportIndicators/customDashboardRegistry'

//@GlobalCustomizeFunction
class QuickSightContent extends React.Component {
  constructor(props) {
    super(props)
    //@Component
    this.yearRef = React.createRef()
    this.kpiYearRef = React.createRef()
    this.certificationKpiRef = React.createRef()
    this.dashboard
    this.mode = this.props.mode
    this.dashboardAuthConf = this.props.dashboardAuthConf
    this.authority = this.props.authority
    this.initInx = this.props.listNum
      ? this.props.listNum
      : this.dashboardList.findIndex((item, idx) =>
          availabilityMiddleTitle(
            this.mode,
            this.dashboardAuthConf,
            item.dashboard,
            this.props.pageInfo.key + '.' + String(idx + 1)
          )
        )
    this.initInxSub = this.props.listNumSub
      ? this.props.listNumSub
      : this.dashboardList[this.initInx].dashboard.findIndex((item, idx) =>
          availabilitySmallTitle(
            this.mode,
            this.dashboardAuthConf,
            item,
            this.props.pageInfo.key + '.' + String(Number(this.initInx) + 1),
            idx
          )
        )
    this.dashboardInfo = this.dashboardList[this.initInx].dashboard[this.initInxSub]
    this.kpiTargetInfo = []
    this.relDashboardList = []
    this.pageInfoList = mainPageInfoList.concat(monitoringInfoList)
    this.industrySector = []
    this.companySize = []
    this.kpiTgtSubInfo = []
    this.certificationKpi = {}
    this.currentFilterRequest = ''
    this.kpiCode = this.props.kpiCode
    this.state = {
      isLoaded: false,
      isDashboardLoaded: false,
      //@ComponentState
      titleIdx: Number(this.initInx),
      dashboardIdx: 0,
      dashboardIdxSub: Number(this.initInxSub),
      isOpenYear: false,
      year: '',
      month: '',
      isYear: true,
      isTotal: true,
      dashboardInfoList: {},
      pageText: null,
      toastMessage: null,
      kpiTargetInfoList: [],
      kpiTargetInfo: {},
      isOpenKpiYear: false,
      relDashboardList: [],
      benchmarkTarget: {},
      benchmarkTargetList: [],
      certificationKpi: [],
      certificationKpiList: [],
      isOpenCertification: false,
      BookmarkContent: <BookmarkEmpty />,
      CategoryTagContent: <CategoryTagEmpty />,
      //フィルター表示
      filterPopup: false,
      dashboardInfo: null,
      //ダッシュボード設定
      dashboardConfigMap: {},
      //ダッシュボードフィルター設定
      dashboardFilterConfig: null,
      //FTE方式年度別
      roundingMethodMap: {}
    }
  }

  dashboardList = this.props.dashboardList

  yearList = []

  //@CustomizeFunction
  getYearList = async (currentYearMonth = null) => {
    try {
      const baseKey = process.env.REACT_APP_FOLDER_DATA_SET_BASE
      let fileKey = this.isMonthly()
        ? process.env.REACT_APP_FOLDER_STANDARD_FORMAT_MONTH
        : process.env.REACT_APP_FOLDER_STANDARD_FORMAT_ANNUAL
      let fileList = await getFileNameList(this.props.bucketName, baseKey + fileKey, orderBy.desc)

      if (process.env.REACT_APP_FOLDER_STANDARD_FORMAT_ANNUAL == fileKey) {
        // 最初のアンダースコアより前が数値のものを取り出し、"年度"をつける
        fileList = fileList
          .map((item) => {
            return item.split('_')[0]
          })
          .filter((item) => {
            return !isNaN(item)
          })
          .map((item) => {
            return item + '年度'
          })
        this.yearList = fileList
        this.setState({
          year: !currentYearMonth ? this.yearList?.[0] || '' : currentYearMonth.year,
          month: ''
        })
      } else if (process.env.REACT_APP_FOLDER_STANDARD_FORMAT_MONTH == fileKey) {
        fileList = fileList
          .map((item) => {
            return item.split('.')[0]
          })
          .filter((item) => {
            return !isNaN(item)
          })
          .map((item) => {
            if (item.length > 4) {
              let m = item.substring(4)
              item = item.substring(0, 4) + '年' + (m.indexOf('0') == 0 ? m.substring(1) : m) + '月'
            }
            return item
          })
        this.yearList = fileList

        this.setState({
          year: !currentYearMonth ? this.yearList[0].substring(0, 5) : currentYearMonth.year,
          month: !currentYearMonth ? this.yearList[0].substring(5) : currentYearMonth.month
        })
      }
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'getYearList', error)
    }
  }

  isCurrentCustomDashboard = (dashboardInfo = this.dashboardInfo) => {
    return isCustomDashboard(dashboardInfo?.key)
  }

  clearEmbeddingContainer = () => {
    const containerDiv = document.getElementById('embeddingContainer')
    if (containerDiv) {
      containerDiv.innerHTML = ''
    }
    this.dashboard = null
  }

  loadCustomDashboard = async () => {
    this.clearEmbeddingContainer()
    this.setState({
      isDashboardLoaded: true,
      BookmarkContent: <BookmarkEmpty />,
      CategoryTagContent: <CategoryTagEmpty />
    })
  }

  /** 10.6.1 の表示対象変更を QuickSight の年度 state に反映（他 QS タブと年度を共有） */
  syncYearFromCustomDashboard = (fiscalYear) => {
    if (!fiscalYear || fiscalYear === this.state.year) {
      return
    }
    this.setState({
      year: fiscalYear,
      month: ''
    })
  }

  getDashboardId = async (isYear, isTotal, dashboardInfoList) => {
    if (this.isCurrentCustomDashboard()) {
      return null
    }
    const ids = dashboardInfoList[this.dashboardInfo.key][this.mode]

    const dashboardId = !this.dashboardInfo.quarterFlg || isYear ? ids.yearDashboardId : ids.quarterDashboardId
    if (!Array.isArray(dashboardId) || dashboardId.length <= 1) {
      return dashboardId
    } else {
      return isTotal ? dashboardId[0] : dashboardId[1]
    }
  }

  getParameters = async (year, month, kpiTargetInfo, benchmarkTarget, certificationKpi) => {
    const categoryList = [
      this.props.pageInfo.key + ' ' + this.state.pageText[this.props.pageInfo.key].name,
      this.state.pageText[this.props.pageInfo.key].dashboardList[this.state.titleIdx].name
    ]
    let parameters = [
      {
        Name: 'ownCorpNum',
        Values: [this.props.corporationNumber]
      },
      {
        Name: 'year',
        Values: [year]
      },
      {
        Name: 'outputCategory',
        Values: [categoryList.join(' > ').replaceAll('&', '＆')]
      },
      {
        Name: 'categoryExplanation',
        Values: [this.state.pageText[this.props.pageInfo.key].dashboardList[this.state.titleIdx]?.categoryExplanation]
      },
      {
        Name: 'cloudFrontUrl',
        Values: [process.env.REACT_APP_URL_FRONT]
      }
    ]
    if (!this.props.isParent || this.mode == analysisMode.standalone) {
      parameters.push({
        Name: 'corpNum',
        Values: [this.props.corporationNumber]
      })
    } else {
      // 権限に応じて表示制御する
      const refAuth = this.props.authority.referenceAuth
      const targets = []
      if (this.props.condition === 'nothing') {
        // 分析対象が「すべて」の場合権限の会社をそのまま設定
        targets.push(
          {
            Name: 'corpNum',
            Values: refAuth.authCompany
          },
          {
            Name: 'segmentCode',
            Values: refAuth.authSegment
          }
        )
      } else {
        // 分析対象が「すべて」以外は権限のない会社を除外
        const corp = this.props.targets.find((t) => t.Name === 'corpNum')
        const segment = this.props.targets.find((t) => t.Name === 'segmentCode')
        targets.push(
          {
            Name: 'corpNum',
            Values: corp?.Values.filter((v) => refAuth.authCompany.includes(v)) ?? []
          },
          {
            Name: 'segmentCode',
            Values: segment?.Values.filter((v) => refAuth.authSegment.includes(v)) ?? []
          }
        )
      }
      targets.map((t) => {
        parameters.push(t)
      })
    }
    if (this.isMonthly()) {
      parameters.push({
        Name: 'month',
        Values: [month]
      })

      const yearNum = parseInt(year, 10)
      const monthNum = parseInt(month, 10)
      const accPeriodNum = parseInt(this.props.accPeriod, 10)
      let fiscalYear
      if (accPeriodNum !== 12 && monthNum <= accPeriodNum) {
        fiscalYear = yearNum - 1
      } else {
        fiscalYear = yearNum
      }
      parameters.push({
        Name: 'fiscalYear',
        Values: [fiscalYear + '年度']
      })
    }

    if (this.props.isKpi) {
      parameters.push({
        Name: 'goal',
        Values: [kpiTargetInfo.value != undefined ? Number(kpiTargetInfo.value) : 0]
      })
    }
    if (
      this.props.isBenchmark && this.mode == analysisMode.standalone
        ? this.dashboardInfo?.benchmarkTarget.standalone
        : this.dashboardInfo?.benchmarkTarget.consolidate
    ) {
      let cl, lc, is, cs
      if (benchmarkTarget.ConditionInfo.ListingClassification.length) {
        lc = benchmarkTarget.ConditionInfo.ListingClassification.map((v) => {
          const c = Object.values(listingClassification).find((item) => item.value === v)
          return c ? c.name : ''
        })
      } else {
        lc = ['ALL_VALUES']
      }
      if (benchmarkTarget.ConditionInfo.IndustrySector.length) {
        is = benchmarkTarget.ConditionInfo.IndustrySector.filter((v1) =>
          this.industrySector.some((v2) => v1 == v2.Key)
        ).map((v1) => {
          const data = this.industrySector.find((v2) => v1 == v2.Key)
          return data.Key + ' ' + data.Name
        })
      } else {
        is = ['ALL_VALUES']
      }
      if (benchmarkTarget.ConditionInfo.CompanySize.length) {
        cs = benchmarkTarget.ConditionInfo.CompanySize.map((v) => this.companySize[v])
      } else {
        cs = ['ALL_VALUES']
      }
      if (benchmarkTarget.ConditionInfo.CompanyList.length) {
        const s3Data = await getBenchmarkCompany(
          this.props.corporationNumber,
          PathInfoList.Folder.benchmarkCompanyFolder + PathInfoList.Objectkeyname.benchmarkCompany,
          'CorporationNumber',
          benchmarkTarget.ConditionInfo.CompanyList
        )
        cl = s3Data.map((d) => d.CorporationName)
      } else {
        cl = ['ALL_VALUES']
      }
      parameters.push(
        {
          Name: 'companyList',
          Values: cl
        },
        {
          Name: 'listingClassification',
          Values: lc
        },
        {
          Name: 'industrySector',
          Values: is
        },
        {
          Name: 'companySize',
          Values: cs
        }
      )
    }
    // 資格情報のパラメータ設定
    if (this.dashboardInfo?.certification?.[this.mode]) {
      let certificationName = certificationKpi?.Name || ''
      parameters.push({
        Name: 'certificationList',
        Values: [certificationName]
      })
    }

    //currentDate
    let latestYearMonth = (await getLatestStdFmtData(this.props.bucketName, this.props.accPeriod)).monthData
    if (/(\d{4})年(\d{1,2})月度/g.test(latestYearMonth)) {
      parameters.push({
        Name: 'currentDate',
        Values: [latestYearMonth?.replaceAll('度', '') || '']
      })
    }

    const curry = (value, fnList) => fnList.reduce((total, e) => e.apply(this, [total]), value)

    // parameters = this.addRoundMethodParameter(parameters)
    // parameters = this.addFiscalYearParameter(parameters)
    parameters = curry(parameters, [
      this.addRoundMethodParameter,
      this.addFiscalYearParameter,
      this.addSecondmentTypeParameter
    ])

    return parameters
  }

  addRoundMethodParameter(params) {
    const roundingSettingMap = this.state.roundingMethodMap
    const currentPeriod = this.state.year

    const roundMethod = roundingSettingMap?.[currentPeriod] ?? ''

    if (!roundMethod) return params
    if (this.dashboardInfo.key !== '1.1.2') return params

    return params.concat({
      Name: 'roundMethod',
      Values: [roundMethod]
    })
  }

  secondmentDashboardKeys = {
    '10.1.5': 'Index-001',
    '10.2.1': 'Index-003',
    '10.4.1': 'Index-002',
    'S2.2.4': 'Index-003',
    'S2.4.6': 'Index-002',
    'S2.4.5': 'Index-001'
  }

  addSecondmentTypeParameter(params) {
    const secondmentType = this.state.secondmentType

    if (!this.secondmentDashboardKeys?.[this.dashboardInfo.key]) return params

    return params.concat({
      Name: 'secondmentType',
      Values: [secondmentType]
    })
  }

  /** @function fetchSecondmentType 出向取扱設定を取得 */
  async fetchSecondmentType() {
    try {
      const secondmentKey = this.secondmentDashboardKeys?.[this.dashboardInfo.key]
      if (!secondmentKey) return

      const secondmentType = await fetchLatestSecondmentType(this.props, secondmentKey)

      this.setState({
        secondmentType
      })
    } catch (error) {
      console.error(error)
    }
  }

  /** @function getRoundingSetting 四捨五入の設定を取得 */
  async getRoundingSetting() {
    try {
      // 資格マスター情報取得
      let fileData = await getObject(
        this.props.bucketName,
        PathInfoList.Folder.employeeCountSettingFolder + PathInfoList.Objectkeyname.employeeCountSetting
      )
      fileData = new File([fileData], PathInfoList.Objectkeyname.employeeCountSetting, { type: 'text/csv' })
      const jsonData = await getCsvByJson(fileData) // blobからjsonに変換

      const periodKey = '年度'
      const roundingMethodKey = '小数設定'

      const roundValue = {
        四捨五入: '2',
        切り捨て: '1'
      }

      const roundingSettingPerPeriod = Object.fromEntries(
        jsonData.map((e) => {
          const period = e[periodKey]
          const value = _get(roundValue, e[roundingMethodKey], '2')
          return [period, value]
        })
      )
      this.setState({
        roundingMethodMap: roundingSettingPerPeriod
      })
      return roundingSettingPerPeriod
    } catch (error) {
      console.error(error)
    }
  }

  addFiscalYearParameter(params) {
    const replaceString = (text) => text.replaceAll(/\D/g, '')

    const year = replaceString(this.state.year)
    const accPeriod = replaceString(this.props.accPeriod)

    const fiscalYear = calculatePeriodtoFiscal(...[year, accPeriod].map(Number))

    if (this.isMonthly()) return params

    return params.concat({
      Name: 'fiscalYear',
      Values: [fiscalYear]
    })
  }

  changeAnalysisTargets(analysisTargets) {
    this.dashboard?.setParameters(analysisTargets)
  }

  getQuickSightDashboardEmbedURL = async (isYear, isTotal, dashboardInfoList) => {
    if (this.isCurrentCustomDashboard()) {
      await this.loadCustomDashboard()
      return
    }
    this.setState({
      isDashboardLoaded: false
    })
    //　ダッシュボードIDを取得
    const dashboardId = await this.getDashboardId(isYear, isTotal, dashboardInfoList)
    try {
      // EmbedURL取得
      await Auth.currentAuthenticatedUser().then(async (user) => {
        const init = {
          queryStringParameters: {
            userName: user.username,
            dashboardId: dashboardId // TODO ダッシュボードの特定
          },
          headers: {}
        }
        httpGet(
          restApiKey.CHROFY_REST_API,
          PathInfoList.Resource.quickSightEmbedUrl(this.props.corporationNumber),
          init
        )
          .then(async (res) => {
            const containerDiv = document.getElementById('embeddingContainer')
            if (!res.EmbedUrl.startsWith('Error generating embedding url:')) {
              if (containerDiv != null) {
                containerDiv.innerHTML = ''
              }
              const paramObj = await this.getParameters(
                this.state.year,
                this.state.month,
                this.state.kpiTargetInfo,
                this.state.benchmarkTarget,
                this.state.certificationKpi
              )

              const frameOptions = {
                url: res.EmbedUrl,
                container: containerDiv,
                height: 'AutoFit',
                width: '100%',
                resizeHeightOnSizeChangedEvent: true,
                onChange: (changeEvent, metadata) => {
                  switch (changeEvent.eventName) {
                    case 'FRAME_LOADED': {
                      this.setState({
                        isDashboardLoaded: true
                      })
                      break
                    }
                  }
                }
              }

              const contentOptions = {
                parameters: paramObj,
                locale: 'ja-JP',
                sheetOptions: {
                  emitSizeChangedEventOnSheetChange: true
                },
                toolbarOptions: {
                  export: true
                },
                attributionOptions: {
                  overlayContent: true
                },
                onMessage: async (messageEvent, experienceMetadata) => {
                  switch (messageEvent.eventName) {
                    case 'NAVIGATE_TO_DASHBOARD': {
                      this.fetchAndCreateOptions()
                    }
                    case 'ERROR_OCCURRED': {
                      this.setState({
                        isDashboardLoaded: true
                      })
                      break
                    }
                  }
                }
              }
              const embeddingContext = await createEmbeddingContext()
              this.dashboard = await embeddingContext.embedDashboard(frameOptions, contentOptions)
            } else {
              containerDiv.innerHTML = 'ダッシュボードのURL取得に失敗しました。画面を再表示してください。'
            }
          })
          .catch((err) => {
            this.setState({
              isDashboardLoaded: true
            })

            throw new Error(err)
          })
      })
    } catch (err) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'getQuickSightDashboardEmbedURL', err)
      this.setState({
        isDashboardLoaded: true
      })
    }
  }

  changeTitle = (value) => {
    if (this.state.titleIdx !== value) {
      this.setState({
        titleIdx: value
      })
      const idxSub = this.dashboardList[value].dashboard.findIndex((item, idx) =>
        availabilitySmallTitle(
          this.mode,
          this.dashboardAuthConf,
          item,
          this.props.pageInfo.key + '.' + String(Number(value) + 1),
          idx
        )
      )
      this.changeDashboard(true, value, idxSub, this.dashboardList[value].dashboard[idxSub])
    }
  }

  setDashboardParams = async () => {
    if (!this.dashboard) return
    const parameters = await this.dashboard.getParameters().catch(console.log)
    if (!parameters) return

    this.setState({ params: parameters })
  }

  changeDashboard = async (isChangeTitle, idx, index, value) => {
    this.toggleDrawer(false)()

    try {
      if (isChangeTitle || this.state.dashboardIdxSub !== index) {
        const totalFlg = this.getTotalFlg(this.state.isYear, idx, index)
        const wasCustomDashboard = this.isCurrentCustomDashboard()
        const isNextCustomDashboard = isCustomDashboard(value?.key)

        this.setState({
          dashboardIdxSub: index,
          isDashboardLoaded: false,
          isTotal: totalFlg,
          BookmarkContent: <BookmarkEmpty />,
          CategoryTagContent: <CategoryTagEmpty />,
          dashboardInfo: value
        })
        this.dashboardInfo = value

        await this.fetchRequiredData()

        if (this.props.isKpi) {
          this.setKpiTargetInfoList()
          this.setRelDashboardList()
        }

        if (isNextCustomDashboard) {
          await this.loadCustomDashboard()
          this.toggleDrawer(false)()
          return
        }

        if (wasCustomDashboard || !this.dashboard) {
          await this.getQuickSightDashboardEmbedURL(this.state.isYear, totalFlg, this.state.dashboardInfoList)
          this.toggleDrawer(false)()
          return
        }

        //　ダッシュボードIDを取得
        const dashboardId = await this.getDashboardId(this.state.isYear, totalFlg, this.state.dashboardInfoList)
        const paramObj = await this.getParameters(
          this.state.year,
          this.state.month,
          this.state.kpiTargetInfo,
          this.state.benchmarkTarget,
          this.state.certificationKpi
        )
        const options = {
          parameters: paramObj
        }

        this.handleFilterReset()

        await this.dashboard.navigateToDashboard(dashboardId, options)

        this.setState({
          BookmarkContent: (
            <Bookmark
              dashboardKey={this.dashboardInfo.key}
              dashboardName={
                this.state.pageText[this.props.pageInfo.key].dashboardList[this.state.titleIdx].dashboard[
                  this.state.dashboardIdxSub
                ].name
              }
              pageId={this.props.pageId}
            />
          ),
          CategoryTagContent: (
            <CategoryTag
              dashboardKey={this.dashboardInfo.key}
              dashboardName={
                this.state.pageText[this.props.pageInfo.key].dashboardList[this.state.titleIdx].dashboard[
                  this.state.dashboardIdxSub
                ].name
              }
              pageId={this.props.pageId}
            />
          )
        })
        this.setState({
          isDashboardLoaded: true
        })
      }
      this.toggleDrawer(false)()
    } catch (error) {
      console.log(error)
      errorLog('E000001', this.props.userId, this.props.pageId, 'changeDashboard', error)
      this.setState({
        isDashboardLoaded: true
      })
    }
  }

  setIsOpenKpiYear = (isOpen) => {
    this.setState({
      isOpenKpiYear: isOpen
    })
    const kpiYearButton = document.getElementById('kpiYearButton')
    if (isOpen) {
      kpiYearButton.classList.add('is-active')
    } else {
      kpiYearButton.classList.remove('is-active')
    }
  }

  setIsOpenYear = (isOpen) => {
    if (this.dashboardInfo.yearFilterFlg) {
      this.setState({
        isOpenYear: isOpen
      })
      const yearButton = document.getElementById('yearButton')
      if (isOpen) {
        yearButton.classList.add('is-active')
      } else {
        yearButton.classList.remove('is-active')
      }
    }
  }

  /**
   * 「資格」セクション開閉状態切り替え・ボタンクラス設定
   *
   * @param {boolean} isOpen - 開閉状態
   */
  setIsOpenCertification = (isOpen) => {
    this.setState({
      isOpenCertification: isOpen
    })
    const certificationButton = document.getElementById('certificationButton')
    if (isOpen) {
      certificationButton.classList.add('is-active')
    } else {
      certificationButton.classList.remove('is-active')
    }
  }

  changeKpiYear = async (value) => {
    try {
      this.setState({
        kpiTargetInfo: value
      })
      this.setIsOpenKpiYear(false)

      this.fetchAndCreateOptions()

      await this.dashboard.reset()
      const paramObj = await this.getParameters(
        this.state.year,
        this.state.month,
        value,
        this.state.benchmarkTarget,
        this.state.certificationKpi
      )
      this.dashboard.setParameters(paramObj)
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'changeYear', error)
    }
  }

  changeYear = async (value) => {
    try {
      let yearVal = value
      let monthVal = ''
      if (this.isMonthly()) {
        yearVal = value.substring(0, 5)
        monthVal = value.substring(5)
      }
      this.setState({
        year: yearVal,
        month: monthVal
      })
      this.setIsOpenYear(false)
      this.fetchAndCreateOptions(yearVal, monthVal)

      const paramObj = await this.getParameters(
        yearVal,
        monthVal,
        this.state.kpiTargetInfo,
        this.state.benchmarkTarget,
        this.state.certificationKpi
      )
      this.dashboard.setParameters(paramObj)
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'changeYear', error)
    }
  }

  changeYearQuarter = async (isYear) => {
    try {
      this.setState({
        isYear: isYear,
        isTotal: this.getTotalFlg(isYear, this.state.titleIdx, this.state.dashboardIdxSub)
      })
      //　ダッシュボードIDを取得
      const dashboardId = await this.getDashboardId(isYear, this.state.isTotal, this.state.dashboardInfoList)
      const paramObj = await this.getParameters(
        this.state.year,
        this.state.month,
        this.state.kpiTargetInfo,
        this.state.benchmarkTarget,
        this.state.certificationKpi
      )
      const options = {
        parameters: paramObj
      }

      await this.dashboard.navigateToDashboard(dashboardId, options)
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'changeYearQuarter', error)
    }
  }

  changeTotalIndividual = async (isTotal) => {
    try {
      this.setState({
        isTotal: isTotal
      })
      //　ダッシュボードIDを取得
      const dashboardId = await this.getDashboardId(this.state.isYear, isTotal, this.state.dashboardInfoList)
      const paramObj = await this.getParameters(
        this.state.year,
        this.state.month,
        this.state.kpiTargetInfo,
        this.state.benchmarkTarget,
        this.state.certificationKpi
      )
      const options = {
        parameters: paramObj
      }

      await this.dashboard.navigateToDashboard(dashboardId, options)
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'changeTotalIndividual', error)
    }
  }

  isIncludeQuater = (list) => {
    for (const item of list) {
      if (item.quarterFlg) {
        return true
      }
    }
    return false
  }

  dashboardKeySort = (a, b) => {
    // 現状は関連ダッシュボードのソートのみに使用するため数値の比較のみ
    // 大見出しでソート
    const aLKey = parseFloat(a.split('.')[0])
    const bLKey = parseFloat(b.split('.')[0])
    if (aLKey != bLKey) {
      if (aLKey > bLKey) return 1
      if (aLKey < bLKey) return -1
    }
    // 中見出しでソート
    const aMKey = parseFloat(a.split('.')[1])
    const bMKey = parseFloat(b.split('.')[1])
    if (aMKey != bMKey) {
      if (aMKey > bMKey) return 1
      if (aMKey < bMKey) return -1
    }
    // 小見出しでソート
    const aSKey = parseFloat(a.split('.')[2])
    const bSKey = parseFloat(b.split('.')[2])
    if (aSKey != bSKey) {
      if (aSKey > bSKey) return 1
      if (aSKey < bSKey) return -1
    }
    return 0
  }

  getRelDashboard = async () => {
    try {
      this.relDashboardList = await getDynamoDB(table.RelatedDashboard, null, this.props.corporationNumber)
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'getRelDashboard', error)
    }
  }

  setRelDashboardList = () => {
    try {
      let relDashboardList = []
      if (this.relDashboardList.length > 0) {
        relDashboardList = this.relDashboardList
          .filter((v) => v.DashboardKey == this.dashboardInfo.key)
          .filter((v) => {
            const largeKey = v.RelDashboardKey.split('.')[0] // 大見出しのキー
            const mIdx = v.RelDashboardKey.split('.')[1] - 1 // 中見出しの要素
            const sIdx = v.RelDashboardKey.split('.')[2] - 1 // 小見出しの要素
            const pageInfo = this.pageInfoList.find((page) => {
              return page.key === largeKey
            })
            if (this.mode == analysisMode.standalone) {
              return pageInfo.dashboardList[mIdx].dashboard[sIdx].activeFlg
            } else if (this.mode == analysisMode.consolidated) {
              return pageInfo.dashboardList[mIdx].dashboard[sIdx].groupFlg
            }
          })
          .map((v) => {
            return v.RelDashboardKey
          })
          .sort((a, b) => this.dashboardKeySort(a, b))
      }
      this.setState({
        relDashboardList: relDashboardList
      })
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'setRelDashboardList', error)
    }
  }

  getKpiTargetInfo = async () => {
    try {
      this.kpiTargetInfo = await getDynamoDB(table.KpiTargetInfo, null, this.props.corporationNumber, {
        Mode: this.mode
      })
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'getKpiTargetInfo', error)
    }
  }

  setKpiTargetInfoList = () => {
    try {
      let kpiTargetInfoList = []
      let kpiTargetInfo = {}
      if (this.kpiTargetInfo.length > 0 && !this.dashboardInfo?.certification?.[this.mode]) {
        let kpiKeyIdx = this.dashboardInfo.key.indexOf('.') + 1
        let array = this.kpiTargetInfo[0].TargetValue.find((v) => v.Key == this.dashboardInfo.key.substring(kpiKeyIdx))
        if (array != undefined) {
          array = array.Value
          for (const [k, v] of Object.entries(array)) {
            if (v.Value != '') {
              kpiTargetInfoList.push({ year: k, value: v.Value })
            }
          }
          if (kpiTargetInfoList.length > 0) {
            kpiTargetInfoList.sort((a, b) => {
              return a['year'] > b['year'] ? 1 : -1
            })
            kpiTargetInfo = kpiTargetInfoList[0]
          }
        }
        // KPI目標値サブテーブルのKPI情報を設定
        // 資格KPI情報を設定
      } else if (this.dashboardInfo?.certification?.[this.mode]) {
        if (this.certificationKpi?.Value) {
          kpiTargetInfoList = Object.keys(this.certificationKpi.Value)
            .map((year) => ({
              year: year,
              value: this.certificationKpi.Value[year].Value
            }))
            .filter((item) => item.value !== '')

          kpiTargetInfo = kpiTargetInfoList.length > 0 ? kpiTargetInfoList[0] : {}
        }
      }
      this.setState({
        kpiTargetInfoList: kpiTargetInfoList,
        kpiTargetInfo: kpiTargetInfo
      })
      return kpiTargetInfo
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'setKpiTargetInfoList', error)
    }
  }

  getBenchmarkTarget = async () => {
    const initData = {
      Key: 0,
      Title: '条件指定なし',
      ConditionInfo: {
        CompanyList: [],
        ListingClassification: [],
        IndustrySector: [],
        CompanySize: []
      }
    }
    try {
      let benchmarkTarget = await getDynamoDB(table.BenchmarkTarget, null, this.props.corporationNumber, null, null)
      // ユーザマスタを取得
      let user = await getDynamoDB(table.User, null, this.props.corporationNumber, null, null)
      if (benchmarkTarget.length > 0) {
        const l1 = benchmarkTarget.filter((l) => user.find((u) => l.UserId === u.UserId)) // 退職者を除く
        const l2 = l1
          .filter((l) => l.UserId === this.props.userId) // 自身が登録した条件
          .sort((a, b) => {
            if (a.Title > b.Title) return 1
            if (b.Title > a.Title) return -1
            return 0
          })
        const l3 = l1
          .filter((l) => l.UserId !== this.props.userId && l.SharedFlag) // 他者が共有した条件（名称に[共有]を付ける）
          .map((l) => {
            return { ...l, Title: l.Title + '[共有]' }
          })
          .sort((a, b) => {
            if (a.Title > b.Title) return 1
            if (b.Title > a.Title) return -1
            return 0
          })
        benchmarkTarget = l2.concat(l3).map((l) => {
          return { Key: l.Key, Title: l.Title, ConditionInfo: l.ConditionInfo }
        })
      }
      benchmarkTarget.unshift(initData)
      this.setState({
        benchmarkTarget: initData,
        benchmarkTargetList: benchmarkTarget
      })
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'getBenchmarkTarget', error)
    }
  }

  getBenchmarkIndustrySector = async () => {
    try {
      let type
      // 女活データの場合 type=2、財務データの場合 type=3
      if (this.props.pageInfo.key == '10') {
        type = '2'
      } else {
        type = '3'
      }
      this.industrySector = await getIndustrySector(this.props.corporationNumber, type)
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'getBenchmarkIndustrySector', error)
    }
  }

  changeBenchmarkTarget = async (value) => {
    const benchmarkTarget = this.state.benchmarkTargetList.find((l) => l.Key === parseInt(value))
    try {
      this.setState({
        benchmarkTarget: benchmarkTarget
      })
      const paramObj = await this.getParameters(
        this.state.year,
        this.state.month,
        this.state.kpiTargetInfo,
        benchmarkTarget,
        this.state.certificationKpi
      )

      this.dashboard.setParameters(paramObj)
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'changeBenchmarkTarget', error)
    }
  }

  /**
   * @function getCertificationNameFromCode 資格コードから資格名を参照
   * @param {string} code - 資格コード
   * @returns {string} 資格名
   */
  getCertificationNameFromCode(code) {
    return this.certificationList?.[code]?.['資格名'] || ''
  }

  /**
   * @function getCertificationDisplayOrderFromCode 資格コードから表示順を参照
   * @param {string} code
   * @returns {number | string} 表示順。資格コードが存在しない場合は空文字列。
   */
  getCertificationDisplayOrderFromCode(code) {
    return parseFloat(this.certificationList?.[code]?.['表示順']) || ''
  }

  /**
   * KPI目標値サブテーブル情報取得関数
   *
   * @async
   * @returns {Promise<Object>} KPI目標値サブテーブル情報
   */
  getKpiTgtSubInfo = async () => {
    try {
      this.kpiTgtSubInfo = await getDynamoDB(table.KpiTargetSubInfo, null, this.props.corporationNumber)
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'getKpiTgtSubInfo', error)
    }
  }

  /**
   * 資格マスター情報取得関数
   *
   * @async
   * @returns {Promise<void>}
   */
  getCertification = async () => {
    try {
      // 資格マスター情報取得
      let fileData = await getObject(
        this.props.bucketName,
        PathInfoList.Folder.certificationFolder + PathInfoList.Objectkeyname.certification
      )
      fileData = new File([fileData], PathInfoList.Objectkeyname.certification, { type: 'text/csv' })
      const jsonData = await getCsvByJson(fileData) // blobからjsonに変換
      // 資格マスター情報ハッシュ変換
      this.certificationList = Object.fromEntries(jsonData.map((e) => [e['資格コード'], e]))
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'getCertification', error)
    }
  }

  /**
   * 資格KPI取得関数
   *
   * @async
   * @returns {Promise<void>} 資格データのフィルタリング、ソートされた資格KPIデータの配列
   */
  setCertificationKpi = async () => {
    // 資格保有者数のKPIキー
    const parentKey = '3.4'
    let certificationKpiList = []
    let selectedCertificationKpi = {}
    let certificationKpi = {}

    // 親KPIキー（「モード#親KPIキー」形式）でフィルター
    const filtered = this.kpiTgtSubInfo.filter((item) => {
      const [itemMode, itemSuperKey] = item.SuperKey.split('#')
      return itemMode === this.props.mode && itemSuperKey === parentKey
    })

    // KPI目標値サブテーブルの目標値からキーと名称を取得
    const certificationKpis = filtered.flatMap((item) => {
      return item.TargetValue.map((value) => {
        // Keyを分割して親キーと資格コードに分ける
        const key = value.Key.split('.')
        const certificationKey = key.slice(2).join('.')
        const name = this.getCertificationNameFromCode(certificationKey)
        const displayOrder = this.getCertificationDisplayOrderFromCode(certificationKey)
        return {
          Key: value.Key,
          Name: name,
          Value: value.Value,
          DisplayOrder: displayOrder
        }
      })
    })
    // DisplayOrderで昇順に並び替え
    certificationKpiList = certificationKpis.sort((a, b) => parseInt(a.DisplayOrder, 10) - parseInt(b.DisplayOrder, 10))

    // KPI目標設定でKPIサブ（資格）を選択した場合、選択された資格を初期値とする（選択されてない場合は、昇順の先頭）
    selectedCertificationKpi = certificationKpiList.find((item) => item.Key === this.kpiCode)
    certificationKpi = selectedCertificationKpi || certificationKpiList[0]

    // インスタンス変数設定
    this.certificationKpi = certificationKpi || {}

    // State設定
    this.setState({
      certificationKpi: certificationKpi,
      certificationKpiList: certificationKpiList
    })
  }

  /**
   * 選択された資格KPIを設定して、ダッシュボードのパラメータを更新
   *
   * @async
   * @param {string} value - 選択された資格KPIのキー。
   * @returns {Promise<void>}
   */
  changeCertificationKpi = async (value) => {
    const certificationKpi = this.state.certificationKpiList.find((l) => l.Key === value)
    this.certificationKpi = certificationKpi
    try {
      this.setState({
        certificationKpi: certificationKpi
      })
      this.setIsOpenCertification(false)
      const KpiTargetInfo = this.setKpiTargetInfoList()
      const paramObj = await this.getParameters(
        this.state.year,
        this.state.month,
        KpiTargetInfo,
        this.state.benchmarkTarget,
        certificationKpi
      )

      this.dashboard.setParameters(paramObj)
    } catch (error) {
      errorLog('E000001', this.props.userId, this.props.pageId, 'changeCertificationKpi', error)
    }
  }

  async fetchRequiredData() {
    await Promise.all([this.getRoundingSetting(), this.fetchSecondmentType()])
  }

  componentDidMount = async () => {
    await this.getYearList()

    this.fetchRequiredData()

    if (this.props.isKpi) {
      // 関連ダッシュボード情報取得
      await this.getRelDashboard()
      this.setRelDashboardList()
      // KPI設定サブ情報（資格）取得
      await this.getCertification()
      await this.getKpiTgtSubInfo()
      this.setCertificationKpi()
      // KPI設定情報取得
      await this.getKpiTargetInfo()
      this.setKpiTargetInfoList()
    }
    if (this.props.isBenchmark) {
      this.companySize = Object.keys(companySizeCode).reduce((l, key) => {
        l[key] = companySizeCode[key].name
        return l
      }, {})
      await this.getBenchmarkIndustrySector()
      await this.getBenchmarkTarget()
    }

    const dashboardInfoList = await readDashboardId(this.props.bucketName)

    const pageText = await getPageText()
    this.setState({
      dashboardInfoList: dashboardInfoList,
      pageText: pageText
    })
    await this.getQuickSightDashboardEmbedURL(this.state.isYear, this.state.isTotal, dashboardInfoList)

    this.setState({
      BookmarkContent: (
        <Bookmark
          t
          dashboardKey={this.dashboardInfo.key}
          dashboardName={
            pageText[this.props.pageInfo.key].dashboardList[this.state.titleIdx].dashboard[this.state.dashboardIdxSub]
              .name
          }
          pageId={this.props.pageId}
        />
      ),
      CategoryTagContent: (
        <CategoryTag
          dashboardKey={this.dashboardInfo.key}
          dashboardName={
            pageText[this.props.pageInfo.key].dashboardList[this.state.titleIdx].dashboard[this.state.dashboardIdxSub]
              .name
          }
          pageId={this.props.pageId}
        />
      )
    })

    this.setState({
      isLoaded: true
    })
    window.scrollTo(0, 0)
    this.fetchAndCreateOptions()
  }

  isMonthly = () => {
    let rs = false
    const keyFirst = this.dashboardInfo.key.substring(0, 1)
    switch (keyFirst) {
      case '6':
        rs = true
        break
    }
    return rs
  }

  getRelDashboardInfo = (key) => {
    const largeKey = key.split('.')[0] // 大見出しのキー
    const mIdx = key.split('.')[1] - 1 // 中見出しの要素
    const sIdx = key.split('.')[2] - 1 // 小見出しの要素
    const pageInfo = this.pageInfoList.find((page) => {
      return page.key === largeKey
    })
    const url = pageInfo.url + mIdx + '/' + sIdx
    const pageText = this.state.pageText[largeKey]
    const name =
      pageText.dashboardList[mIdx].dashboard[sIdx].name +
      (pageInfo.dashboardList[mIdx].dashboard[sIdx].quarterFlg ? ' [Y/Q]' : '')
    // 参照権限があるか判定
    let availability = false
    if (this.authority.Dashboard_AuthInfo.Availability) {
      // ダッシュボードへの参照権限がある
      let authConf = this.authority.Dashboard_AuthInfo.Auth_Conf.find((auth) => auth.Key === largeKey)
      if (authConf?.Availability) {
        // 大見出しレベルで参照権限がある
        const mDashboardId = largeKey + '.' + String(mIdx + 1)
        const dashboardList = authConf.DashboardList.find((d) => d.Key === mDashboardId)
        if (dashboardList?.Availability) {
          // 中見出しレベルで参照権限がある
          const sDashboardId = mDashboardId + '.' + (sIdx + 1)
          const authDashboard = dashboardList.Dashboard.find((d) => d === sDashboardId)
          if (authDashboard) {
            // 小見出しレベルで参照権限がある
            availability = true
          }
        }
      }
    }
    return {
      name: name,
      url: url,
      img: pageInfo.dashboardList[mIdx].dashboard[sIdx].img,
      availability: availability
    }
  }

  getTotalFlg = (isYear, titleIdx, idxSub) => {
    const d = this.dashboardList[titleIdx].dashboard[idxSub]

    if (isYear || !d.quarterFlg) {
      return d.consolidatedYear.totalFlg
    } else {
      return d.consolidatedQuarter.totalFlg
    }
  }

  getIndividualFlg = (isYear, titleIdx, idxSub) => {
    const d = this.dashboardList[titleIdx].dashboard[idxSub]
    if (isYear || !d.quarterFlg) {
      return d.consolidatedYear.individualFlg
    } else {
      return d.consolidatedQuarter.individualFlg
    }
  }

  //フィルタードロアーの切り替え
  toggleDrawer = (state) => {
    const drawerWidth = 485

    return () => {
      const popupState = state !== undefined ? state : !this.state.filterPopup

      this.setState({
        filterPopup: popupState
      })

      if (!document) return
      const pageContent = document.querySelector('.page-content')

      if (!pageContent) return

      pageContent.style.transition = `max-width 500ms ease-in-ease-out`
      pageContent.style.maxWidth = popupState ? `calc(100% - ${drawerWidth}px)` : '100%'
    }
  }

  //フィルタの変更
  handleChangeFilter = debounce(async (state) => {
    if (!this.dashboard) return

    const message = await this.dashboard.setParameters(state).catch(console.log)

    if (!message?.success) {
      console.error('フィルターの更新失敗しました')
    }
  }, 500)

  /** @function fetchAndCreateOptions 現在選択されている年次データから表示条件を算出 */
  fetchAndCreateOptions = async (year = this.state.year, month = this.state.month) => {
    let dashboardInfo = this.state.dashboardInfo === null ? this.dashboardInfo : this.state.dashboardInfo
    this.currentFilterRequest = dashboardInfo.key
    const dashboardId = dashboardInfo.key

    //ダッシュボードリセット
    this.toggleDrawer(false)()
    this.setState({
      dashboardFilterConfig: null
    })

    const yearMonth = `${year || ''}${month || ''}`

    const params = {
      dashboardId,
      yearMonth,
      props: this.props
    }

    let args = [params]
    const secondmentCode = this.secondmentDashboardKeys?.[dashboardId]
    if (secondmentCode) args.push(secondmentCode)

    try {
      const config = await this.dashboardConfig[dashboardInfo.key]?.(...args)
      if (!config) throw new Error('設定見つかりませんでした')

      this.setState({
        dashboardFilterConfig: this.currentFilterRequest === dashboardInfo.key ? config : null
      })

      return config
    } catch (error) {
      console.warn(error)
      warnLog('E000001', '', 'quicksight', 'resetCondition', error)
    }
  }

  dashboardConfig = filterConfig

  handleFilterReset = () => {
    this.setState({
      dashboardFilterConfig: null,
      filterPopup: false
    })
  }

  getFiscalPeriod() {
    const month = this.state.month ? this.state.month : this.props.accPeriod
    const isMonthly = this.isMonthly()
    const year = this.state.year

    if (this.yearList?.length === 0) {
      return ''
    }

    return `${year}${month}${isMonthly ? '度' : '期'}`
  }

  render() {
    if (!this.state.isLoaded) {
      return null
    }

    const isFilterDisabled = !this.state.dashboardFilterConfig || !this.state.isDashboardLoaded
    const isCustomDashboardView = this.isCurrentCustomDashboard()
    const CustomDashboardComponent = isCustomDashboardView ? getCustomDashboardComponent(this.dashboardInfo.key) : null
    // タイトル設定
    document.title = this.state.pageText[this.props.pageInfo.key].name + titleName.common
    return (
      <React.Fragment>
        {/* コンテンツヘッダ */}
        <header className="category-page-header flex items-center my-6">
          {this.props.pageInfo.img && (
            <div className="category-page-header__img ml-4 mr-8">
              <img src={this.props.pageInfo.img} alt="" />
            </div>
          )}
          <div className={`pl-8 relative ${this.props.pageInfo.img ? ' category-page-header__text' : ''}`}>
            <div className="category-page-header__subtitle flex items-center red--text">
              {this.state.pageText[this.props.pageInfo.key].id && this.props.pageInfo.monitoring == null && (
                <span className="category-page-header__subtitle-number text-h4-en">
                  {this.state.pageText[this.props.pageInfo.key].id}
                </span>
              )}
              {this.state.pageText[this.props.pageInfo.key].nameEng && (
                <span className="category-page-header__subtitle-text text-h6-en ml-7">
                  {this.state.pageText[this.props.pageInfo.key].nameEng}
                </span>
              )}
            </div>
            <h1 className="category-page-header__title">
              <span className="category-page-header__title-text text-h2">
                {this.props.pageInfo.monitoring && <span>{this.state.pageText[this.props.pageInfo.key].id} </span>}
                {this.state.pageText[this.props.pageInfo.key].name}
              </span>
            </h1>
            <p className="category-page-header__description text-caption-2 grey--text text--lighten-70">
              {this.state.pageText[this.props.pageInfo.key].explanation}
            </p>
          </div>
        </header>
        {/* コンテンツボディ */}
        <div className="page-body">
          {/* ===== カテゴリーナビゲーション ===== */}
          {/*
                  ■ナビゲーションのアクティブ表示について
                  選択しているカテゴリーのli要素に is-active クラスを入れてください
                  ■ナビゲーションの非活性表示について
                  カテゴリーのli要素に is-disabled クラスを入れてください
                */}
          {this.dashboardList.length > 1 ? (
            <ul className="nav-category grey rounded-t-lg flex justify-center flex-wrap">
              {this.dashboardList.map((item, index) => {
                // 権限制御
                let availability = false
                const mDashboardId = this.props.pageInfo.key + '.' + String(index + 1)
                const middleFlg = availabilityMiddleTitle(
                  this.mode,
                  this.dashboardAuthConf,
                  this.props.pageInfo.dashboardList[index].dashboard,
                  mDashboardId
                )
                if (middleFlg) {
                  const smallFlg = this.props.pageInfo.dashboardList[index].dashboard.findIndex((item, idx) =>
                    availabilitySmallTitle(this.mode, this.dashboardAuthConf, item, mDashboardId, idx)
                  )
                  if (smallFlg !== -1) {
                    availability = true
                  }
                }
                return (
                  <li
                    key={index}
                    className={`
                            nav-category__item
                            ${this.state.titleIdx === index ? ' is-active' : ''}
                            ${!this.state.isDashboardLoaded ? ' nav-category__item-load' : ''}
                            ${availability ? '' : 'is-disabled'}
                          `}
                  >
                    <button
                      type="button"
                      className={`
                              nav-category__btn
                              text-h6 px-4 py-3 mx-6
                            `}
                      disabled={!this.state.isDashboardLoaded}
                      onClick={() => this.changeTitle(index)}
                    >
                      {this.state.pageText[this.props.pageInfo.key].dashboardList[index].name}
                      {this.isIncludeQuater(item.dashboard) ? ' [Y/Q]' : ''}
                    </button>
                  </li>
                )
              })}
            </ul>
          ) : (
            <div className="nav-category grey rounded-lg flex justify-center nav-category-empty"></div>
          )}
          {/* ===== /カテゴリーナビゲーション ===== */}
          {/* ===== グラフナビゲーション ===== */}
          {/*
                  ■ナビゲーションのアクティブ表示について
                  選択しているカテゴリーのli要素に is-active クラスを入れてください
                  ■ナビゲーションの非活性表示について
                  カテゴリーのli要素に is-disabled クラスを入れてください
                */}
          <div className="box-graph__header pt-4 pb-5 px-2 rounded-b-lg white mb-8">
            <ul className="nav-graph flex flex-wrap pb-0.5 pb-px">
              {this.dashboardList[this.state.titleIdx].dashboard.map((item, index) => {
                const path = [this.props.pageInfo.key, 'dashboardList', this.state.titleIdx, 'dashboard', index, 'name']
                const dashboardName = _get(this.state.pageText, path, '')
                // 権限制御
                const mDashboardId = this.props.pageInfo.key + '.' + String(this.state.titleIdx + 1)
                const sDashboardId = mDashboardId + '.' + String(index + 1)
                const dashboardList = this.dashboardAuthConf.DashboardList.find((d) => d.Key === mDashboardId)
                const dashboard = dashboardList?.Dashboard.find((d) => d === sDashboardId)
                return (
                  <div key={index}>
                    <li
                      className={`
                            nav-graph__item
                            ${this.state.dashboardIdxSub === index ? ' is-active' : ''}
                            ${!this.state.isDashboardLoaded ? ' nav-graph__item-load' : ''}
                            ${
                              (this.mode == analysisMode.consolidated && !item.groupFlg) ||
                              (this.mode == analysisMode.standalone && !item.activeFlg) ||
                              !dashboard
                                ? ' is-disabled'
                                : ''
                            }
                          `}
                    >
                      <button
                        type="button"
                        className="nav-graph__btn text-h6 px-2 py-1.5 mx-4 my-1"
                        disabled={!this.state.isDashboardLoaded}
                        onClick={() => this.changeDashboard(false, this.state.titleIdx, index, item)}
                      >
                        <span className="nav-graph__text">
                          {dashboardName}
                          {item.quarterFlg ? ' [Y/Q]' : ''}
                        </span>
                        {this.state.isDashboardLoaded && (
                          <span className="nav-graph__preview">
                            <img src={item.img} alt="" />
                          </span>
                        )}
                      </button>
                    </li>
                  </div>
                )
              })}
            </ul>
          </div>
          {/* ===== /グラフナビゲーション ===== */}

          <div className="box-graph rounded-2xl white">
            {/* ===== カテゴリータイトルとコントロール ===== */}
            {!isCustomDashboardView && (
              <div className="dashboard-title-area flex justify-between items-center pl-10 pr-8">
                {/* ===== カテゴリータイトル ===== */}
                <div className="dashboard-title py-8">
                  <h2 className="dashboard-title__name text-h3">
                    {
                      this.state.pageText[this.props.pageInfo.key].dashboardList[this.state.titleIdx].dashboard[
                        this.state.dashboardIdxSub
                      ].name
                    }
                  </h2>
                </div>
                {/* ===== /カテゴリータイトル ===== */}
                {/* ===== コントロール ===== */}
                <div className="action-area flex">
                  {/* ブックマーク */}
                  {this.state.BookmarkContent}
                  {/* 用途タグ */}
                  {this.state.CategoryTagContent}
                  {/* 年度選択 */}
                  <div className="action-area__year-select">
                    <div
                      className="year-container"
                      tabIndex="0"
                      ref={this.yearRef}
                      onBlur={() => this.setIsOpenYear(false)}
                    >
                      {/*
                      ■yearButtonについて
                      クリックしてドロップダウンリストを開いた状態は yearButton クラスに is-active クラスを追加してください。
                      <div className="yearButton is-active flex items-center justify-between rounded-xl pl-4 pr-2">

                      disabled状態は yearButton クラスに is-disabled クラスを追加してください。
                      <div className="yearButton is-disabled flex items-center justify-between rounded-xl pl-4 pr-2">
                    */}
                      <div
                        id="yearButton"
                        className={`yearButton flex items-center justify-between rounded-xl pl-4 pr-2 ${
                          !this.state.isDashboardLoaded ||
                          !this.dashboardList[this.state.titleIdx].dashboard[this.state.dashboardIdxSub].yearFilterFlg
                            ? ' is-disabled'
                            : ''
                        }`}
                        onClick={() => this.setIsOpenYear(!this.state.isOpenYear)}
                      >
                        <div className="yearButton__text text-h7 mr-2">{this.state.year + this.state.month}</div>
                        <div className="yearButton__icon flex items-center justify-center w-8 h-8">
                          <span className="icon-arrow"></span>
                        </div>
                      </div>
                      {/*
                      通常は
                      <ul className="year" hidden>
                    */}
                      <ul className="year rounded-xl" hidden={!this.state.isOpenYear || !this.state.isDashboardLoaded}>
                        {this.yearList.map((value, index) => {
                          return (
                            <li key={index} className="item text-h7" onClick={() => this.changeYear(value)}>
                              {' '}
                              {value}{' '}
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                  </div>
                  {/* 年度/四半期選択 */}
                  <div className="action-area__year-quarter ml-4">
                    <div className="radioArea rounded-xl flex gap-x-2" id="makeImg">
                      <input
                        type="radio"
                        name="yearQuarter"
                        id="year"
                        onClick={() => this.changeYearQuarter(true)}
                        defaultChecked={this.state.isYear}
                        className="hidden"
                        disabled={
                          !this.state.isDashboardLoaded ||
                          !this.dashboardList[this.state.titleIdx].dashboard[this.state.dashboardIdxSub].quarterFlg
                        }
                      />
                      <label htmlFor="year" className="text-h7 rounded">
                        年度
                      </label>
                      <input
                        type="radio"
                        name="yearQuarter"
                        id="quarter"
                        onClick={() => this.changeYearQuarter(false)}
                        defaultChecked={!this.state.isYear}
                        className="hidden"
                        disabled={
                          !this.state.isDashboardLoaded ||
                          !this.dashboardList[this.state.titleIdx].dashboard[this.state.dashboardIdxSub].quarterFlg
                        }
                      />
                      <label htmlFor="quarter" className="text-h7 rounded">
                        四半期
                      </label>
                    </div>
                  </div>
                  {/* 合算/内訳選択 */}
                  {(() => {
                    const content = (isYear) => {
                      const totalFlg = this.getTotalFlg(isYear, this.state.titleIdx, this.state.dashboardIdxSub)
                      const individualFlg = this.getIndividualFlg(
                        isYear,
                        this.state.titleIdx,
                        this.state.dashboardIdxSub
                      )
                      return (
                        <div className="action-area__total-individual ml-4">
                          <div className="radioArea rounded-xl flex gap-x-2" id="makeImg">
                            <input
                              type="radio"
                              name="totalIndividual"
                              id="total"
                              onClick={() => this.changeTotalIndividual(true)}
                              checked={(this.state.isTotal && totalFlg) || !individualFlg}
                              className="hidden"
                              disabled={!this.state.isDashboardLoaded || !totalFlg}
                            />
                            <label htmlFor="total" className="text-h7 rounded">
                              合算
                            </label>
                            <input
                              type="radio"
                              name="totalIndividual"
                              id="individual"
                              onClick={() => this.changeTotalIndividual(false)}
                              checked={(!this.state.isTotal && individualFlg) || !totalFlg}
                              className="hidden"
                              disabled={!this.state.isDashboardLoaded || !individualFlg}
                            />
                            <label htmlFor="individual" className="text-h7 rounded">
                              内訳
                            </label>
                          </div>
                        </div>
                      )
                    }
                    // 連結モード時に表示する
                    if (this.mode === analysisMode.consolidated) {
                      return content(this.state.isYear)
                    }
                  })()}

                  {
                    <div className={`action ml-3 flex items-center !h-[46px] !w-[46px]  `}>
                      <IconButton
                        data-testid="filterButton"
                        disabled={isFilterDisabled}
                        aria-describedby="filter-menu"
                        onClick={this.toggleDrawer()}
                        className={` !p-0 !h-[46px] !w-[46px]  !rounded-xl cursor-pointer !border !border-solid !border-[#7476a64d] text-bold !text-[#38394759] ${
                          isFilterDisabled && '!bg-[#E1E6ED] !text-[#38394759] !border-[#7476a626]'
                        } `}
                      >
                        <span className="hover:!text-gray-700 icon-filter text-[32px]" />
                      </IconButton>
                    </div>
                  }
                </div>

                {/* ===== /コントロール ===== */}
              </div>
            )}
            {/* ===== /カテゴリータイトルとコントロール ===== */}
            {/* S2_人的資本KPI画面もしくは10_法廷開示レポート画面で表示する */}
            {!isCustomDashboardView && (this.props.isKpi || this.props.isBenchmark) && (
              <div className="box-graph__middle w-full flex justify-center items-center">
                <ul className="nav-graph flex flex-wrap pt-6 pb-px">
                  {this.props.isKpi && this.dashboardInfo?.certification?.[this.mode] && (
                    <li className="nav-graph__item px-4">
                      {/* 資格 */}
                      <div className="box-graph__target-fiscal-year flex justify-center items-center">
                        <div className="text-h5">資格：</div>
                        {/* 資格選択 */}
                        {this.state.certificationKpiList.length > 0 && (
                          <div className="action-area min-w-[400px]">
                            <div
                              className="year-container"
                              tabIndex="0"
                              ref={this.certificationKpiRef}
                              onBlur={() => this.setIsOpenCertification(false)}
                            >
                              <div
                                id="certificationButton"
                                className={`yearButton flex items-center justify-between rounded-xl pl-4 pr-2 max-w-[400px]${
                                  !this.state.isDashboardLoaded ? ' is-disabled' : ''
                                }`}
                                style={{
                                  paddingTop: '4px',
                                  paddingBottom: '4px'
                                }}
                                onClick={() => this.setIsOpenCertification(!this.state.isOpenCertification)}
                              >
                                <div className="yearButton__text text-h7 mr-2 truncate">
                                  {this.state.certificationKpi.Name}
                                </div>
                                <div className="yearButton__icon flex items-center justify-center w-8 h-8">
                                  <span className="icon-arrow"></span>
                                </div>
                              </div>
                              <ul
                                className="year rounded-xl"
                                hidden={!this.state.isOpenCertification || !this.state.isDashboardLoaded}
                              >
                                {this.state.certificationKpiList.map((value, index) => {
                                  return (
                                    <li
                                      key={index}
                                      className="item text-h7"
                                      onClick={() => this.changeCertificationKpi(value.Key)}
                                    >
                                      {' '}
                                      {value.Name}{' '}
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          </div>
                        )}
                        {this.state.certificationKpiList.length == 0 && (
                          <div className="text-h5 red--text py-2">資格未設定</div>
                        )}
                      </div>
                    </li>
                  )}
                  {this.props.isKpi && (
                    <li className="nav-graph__item px-4">
                      {/* 目標値の対象年度 */}
                      {/* 目標値の対象年度の表示・設定
                          目標未設定時は、box-graph__target-fiscal-yearクラスにhiddenクラスを追加してください
                      */}
                      <div className="box-graph__target-fiscal-year flex justify-center items-center">
                        <div className="text-h5">目標値の対象年度：</div>
                        {/* 年度選択 */}
                        {this.state.kpiTargetInfoList.length > 0 && (
                          <div className="action-area">
                            <div
                              className="year-container"
                              tabIndex="0"
                              ref={this.yearRef}
                              onBlur={() => this.setIsOpenKpiYear(false)}
                            >
                              {/*
                                ■yearButtonについて
                                クリックしてドロップダウンリストを開いた状態は yearButton クラスに is-active クラスを追加してください。
                                <div className="yearButton is-active flex items-center justify-between rounded-xl pl-4 pr-2">
          
                                disabled状態は yearButton クラスに is-disabled クラスを追加してください。
                                <div className="yearButton is-disabled flex items-center justify-between rounded-xl pl-4 pr-2">
                              */}
                              <div
                                id="kpiYearButton"
                                className={`yearButton flex items-center justify-between rounded-xl pl-4 pr-2 ${
                                  !this.state.isDashboardLoaded ? ' is-disabled' : ''
                                }`}
                                style={{
                                  paddingTop: '4px',
                                  paddingBottom: '4px'
                                }}
                                onClick={() => this.setIsOpenKpiYear(!this.state.isOpenKpiYear)}
                              >
                                <div className="yearButton__text text-h7 mr-2">
                                  {this.state.kpiTargetInfo.year} {this.props.accPeriod}期
                                </div>
                                <div className="yearButton__icon flex items-center justify-center w-8 h-8">
                                  <span className="icon-arrow"></span>
                                </div>
                              </div>
                              {/*
                                通常は
                                <ul className="year" hidden>
                              */}
                              <ul
                                className="year rounded-xl"
                                hidden={!this.state.isOpenKpiYear || !this.state.isDashboardLoaded}
                              >
                                {this.state.kpiTargetInfoList.map((value, index) => {
                                  return (
                                    <li key={index} className="item text-h7" onClick={() => this.changeKpiYear(value)}>
                                      {' '}
                                      {value.year} {this.props.accPeriod}期{' '}
                                    </li>
                                  )
                                })}
                              </ul>
                            </div>
                          </div>
                        )}
                        {this.state.kpiTargetInfoList.length == 0 && (
                          <div className="text-h5 red--text py-2">目標値未設定</div>
                        )}
                      </div>
                    </li>
                  )}
                  {/* /目標値の対象年度 */}
                  {(() => {
                    {
                      /* ベンチマーク対象 */
                    }
                    if (this.props.isBenchmark) {
                      // 設定ファイルからベンチマーク対象プルダウンを表示するか判定
                      const isVisible =
                        this.mode == analysisMode.standalone
                          ? this.dashboardInfo?.benchmarkTarget.standalone
                          : this.dashboardInfo?.benchmarkTarget.consolidate
                      if (isVisible) {
                        return (
                          <li className={'nav-graph__item'}>
                            <div className="box-graph__target-fiscal-year flex justify-end items-center px-4">
                              <div className="form-control text-nowrap">
                                <div className="select-control flex justify-center items-center">
                                  <div className="text-h5">ベンチマーク対象：</div>
                                  <select
                                    className="form-select select-p-large rounded-lg text-h7 pr-10"
                                    style={{ width: '200px' }}
                                    value={this.state.benchmarkTarget.Key}
                                    onChange={(e) => this.changeBenchmarkTarget(e.target.value)}
                                    disabled={!this.state.isDashboardLoaded}
                                  >
                                    {this.state.benchmarkTargetList.map((bt, idx) => {
                                      return (
                                        <option key={idx} value={bt.Key}>
                                          {bt.Title}
                                        </option>
                                      )
                                    })}
                                  </select>
                                  <div className="select-control__icon flex text-base items-center justify-center w-8 absolute pointer-events-none inset-y-0 right-0">
                                    <span className="icon-arrow rotate-90"></span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                        )
                      }
                    }
                  })()}
                  {/* /ベンチマーク対象 */}
                </ul>
              </div>
            )}

            {/* <venu
              id="filter-menu"
              anchorEl={this.state.filterPopup}
              open={Boolean(this.state.filterPopup)}
              onClose={this.handleDrawerClose}
              disableScrollLock
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            ></Menu> */}

            {/* ===== グラフ ===== */}
            <div className="box-graph__body">
              {isCustomDashboardView && CustomDashboardComponent ? (
                <CustomDashboardComponent
                  {...this.props}
                  dashboardInfo={this.dashboardInfo}
                  selectedFiscalYear={this.state.year}
                  onSelectedFiscalYearChange={this.syncYearFromCustomDashboard}
                />
              ) : (
                <div id="embeddingContainer">
                  <div className="py-8">
                    <div className="dashboard-loading">
                      <img src={LoadingIcon} alt="LoadingIcon" />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* ===== /グラフ ===== */}
          </div>
          {/* /box-graph */}

          {/* 関連コンテンツ */}
          {this.props.isKpi && (
            <div className="box-graph rounded-2xl white -mt-px pt-12 pb-16">
              <h2 className="text-h3 text-center mb-6">関連ダッシュボード</h2>
              <ul className="nav-graph flex flex-wrap justify-center pb-0.5 pb-px mx-32">
                {this.state.relDashboardList.map((item, index) => {
                  let relDashboardInfo = this.getRelDashboardInfo(item)
                  return (
                    <li
                      key={index}
                      className={`nav-graph__item ${!relDashboardInfo.availability ? 'is-disabled' : ''}`}
                    >
                      <button type="button" className="nav-graph__btn text-h6 px-2 py-1.5 mx-4 my-1">
                        {(() => {
                          const label = <span className="nav-graph__text">{relDashboardInfo.name}</span>
                          if (relDashboardInfo.availability) {
                            return (
                              <React.Fragment>
                                <Link underline="none" href={relDashboardInfo.url} target="_blank">
                                  {label}
                                </Link>
                                <span className="nav-graph__preview">
                                  <img src={relDashboardInfo.img} alt="" />
                                </span>
                              </React.Fragment>
                            )
                          } else {
                            return label
                          }
                        })()}
                      </button>
                    </li>
                  )
                })}
              </ul>
            </div>
          )}

          {/* /関連コンテンツ */}

          {/* 集計条件 */}

          {(this.state.dashboardInfo || this.dashboardInfo) && (
            <AggregateCondition
              periodType={this.isMonthly() ? 'monthly' : 'year'}
              fiscalPeriod={this.getFiscalPeriod()}
              dashboardId={(this.state.dashboardInfo || this.dashboardInfo).key}
            />
          )}

          {/* 集計条件 */}
        </div>

        {((config = {}) => {
          const dashboardInfo = this.state.dashboardInfo || this.dashboardInfo
          if (config !== null && Object.keys(config).length > 0)
            return (
              <FilterComponent
                {...config}
                dashboardId={dashboardInfo.key}
                show={this.state.filterPopup}
                onValueChange={this.handleChangeFilter}
                onClose={this.toggleDrawer(false)}
                mode={this.props.mode}
              />
            )
        })(this.state.dashboardFilterConfig)}
      </React.Fragment>
    )
  }
}

/**
 * @function calculateFiscalYear
 * @param {number} year
 * @param {number} month
 * @param {number} accPeriod 決算期
 */
export const calculatePeriodtoFiscal = (year = 0, accPeriod = 0) => {
  if (!year) return ''

  const yearNum = parseInt(year, 10)
  const accPeriodNum = parseInt(accPeriod, 10)

  if ([accPeriod].some((e) => e === null || e === undefined || e < 0 || e === '')) {
    throw new Error('エラー')
  }

  let fiscalYear = yearNum
  if (accPeriodNum !== 12) fiscalYear = yearNum + 1

  return `${fiscalYear}年${accPeriod}月期`
}

const QuickSight = (props) => {
  const userState = useSelector((state) => state.user)
  const companyState = useSelector((state) => state.company)
  const analysisState = useSelector((state) => state.analysis)
  const authorityState = useSelector((state) => state.authority)
  const isFirstRender = React.useRef(true)
  const childRef = React.createRef()

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)

  // 権限制御
  let availability = false
  let dashboardAuthConf
  if (authorityState.Dashboard_AuthInfo.Availability) {
    // ダッシュボードへの参照権限がある
    dashboardAuthConf = authorityState.Dashboard_AuthInfo.Auth_Conf.find((auth) => auth.Key === props.pageInfo.key)
    if (dashboardAuthConf?.Availability) {
      // 大見出しレベルで参照権限がある
      if (props.params.listNum === undefined) {
        availability = true
      } else {
        const mDashboardId = props.pageInfo.key + '.' + String(Number(props.params.listNum) + 1)
        const dashboardList = dashboardAuthConf.DashboardList.find((d) => d.Key === mDashboardId)
        if (dashboardList?.Availability) {
          // 中見出しレベルで参照権限がある
          if (props.params.listNumSub === undefined) {
            availability = true
          } else {
            const sDashboardId = mDashboardId + '.' + (Number(props.params.listNumSub) + 1)
            const authDashboard = dashboardList.Dashboard.find((d) => d === sDashboardId)
            if (authDashboard) {
              // 小見出しレベルで参照権限がある
              const dashboard = props.pageInfo.dashboardList[props.params.listNum].dashboard[props.params.listNumSub]
              if (
                (analysisState.mode === analysisMode.standalone && dashboard.activeFlg) ||
                (analysisState.mode === analysisMode.consolidated && dashboard.groupFlg)
              ) {
                availability = true
              }
            }
          }
        }
      }
    }
  }

  React.useEffect(() => {
    // 初回レンダリング時は実行しない
    if (isFirstRender.current) {
      isFirstRender.current = false
      return
    }
    childRef.current.changeAnalysisTargets(analysisState.targets)
  }, [analysisState])

  if (availability) {
    return (
      <QuickSightContent
        pageId={props.pageId}
        pageInfo={props.pageInfo}
        dashboardList={props.dashboardList}
        listNum={props.params.listNum}
        listNumSub={props.params.listNumSub}
        isKpi={props.isKpi}
        isBenchmark={props.isBenchmark}
        userId={userState.sub}
        corporationNumber={companyState.corporationNumber}
        accPeriod={companyState.accPeriod}
        bucketName={'chrofy-' + process.env.REACT_APP_ENV + '-' + companyState.corporationNumber}
        mode={analysisState.mode}
        condition={analysisState.condition}
        targets={analysisState.targets || []}
        authority={authorityState}
        dashboardAuthConf={dashboardAuthConf}
        isParent={companyState.isParent}
        ref={childRef}
        kpiCode={queryParams.get('kpiCode') || ''}
      />
    )
  } else {
    return <Forbidden />
  }
}

export default (props) => <QuickSight {...props} params={useParams()} />
